import {segment} from './helpers'
import * as api from '../api/api'

export const fitInformationModalOpened = () => segment('Opened Fit Information Modal')
export const fitReccoMainButtonClicked = () => segment('Clicked Fit Recco Main Button')
export const fitSurveyBackClicked = () => segment('Clicked Fit Survey Back')

export const fitSurveyStepSubmitted = (value, source) =>
  segment('Submitted Fit Survey Step', {
    value,
    source,
  })

/**
 * Used for tracking when a user has started a fit flow. Currently these would be fired either when
 * the user has entered the Fit Survey via the CTA from the Fit Intro landing page, or when the user
 * has entered the DB Fit Form from one of two CTAs, the link on the Fit Intro landing page or the
 * CTA on the new DB Fit landing page. This tracking call replaces the previous `findYourFitClicked`
 * call which instrumented the `Clicked Find Your Fit` event when the user clicked the CTA on the
 * Fit Intro landing page.
 *
 * @param {Object} [trackingProperties]
 * @param {string} [trackingProperties.customerType] user's customer type
 * @param {string} [trackingProperties.flow] name of the flow user went through
 * @return {undefined} no return value for this as it just fires the analytics call
 */
export const startedFitFlow = ({customerType, flow}) =>
  segment('Started Fit Flow', {customerType, flow})

/**
 * Used for tracking when a user has completed a fit flow. Currently these would be fired either
 * when the user has completed the Fit Survey via the CTA from the last Fit Survey step, or when the
 * user has completed the DB Fit Form and clicked the submit button. This tracking call replaces the
 * previous `fitSurveyCompleted` call which instrumented the `Completed Fit Survey Client` event
 * when the user clicked the CTA from the last Fit Survey step.
 *
 * @param {Object} [trackingProperties]
 * @param {string} [trackingProperties.customerType] user's customer type
 * @param {string} [trackingProperties.email] user's email
 * @param {string} [trackingProperties.flow] name of the flow user went through
 * @return {undefined} no return value for this as it just fires the analytics calls
 */
export const completedFitFlow = ({customerType, email, flow}) => {
  // uniqueId for analytics testing purposes, tying together FE and BE events
  const uniqueId = `${email}-${Date.now()}`

  // we make a call to the API which will create the same event as the call below
  // this is to be consistent with some of our other funnels (registration, add product),
  // which utilize the backend-intitiated tracking events over the frontend ones.
  api.trackFitFlowCompleted(uniqueId, flow)

  // we also fire the event from the frontend to allow for comparison
  segment('Completed Fit Flow Client', {
    customerType,
    email,
    flow,
    uniqueId,
  })
}

/**
 * Tracks where there is a 400 error when saving a fitprofile.
 *
 * @param {Object} [trackingProperties]
 * @param {Array.<string>} [trackingProperties.errors] errors surfaced from invalid fitprofile save attempt
 * @param {Object} [trackingProperties.fitProfileData] data in the failed save attempt
 */
export const failedToSaveFitProfile = ({errors, fitProfileData}) => {
  segment('Failed to Save Fit Profile', {
    errors,
    fitProfileData,
  })
}
